/* global fetch */

import React, { Component } from 'react';
import { Link, hashHistory } from 'react-router';
import lang from '../services/lang';
import Icon from '../components/Icon';
import './subscribe.css';
import { conditions } from '../services/content';
import { beep } from '../services/audio';
import { trackView } from '../services/analytics';

const emailExp = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

export default class Subscribe extends Component {
  
  constructor() {
    super();
    this.state = {
      email: "",
      condition: "",
      isSent: false,
      error: "",
      isErrorVisible: false,
    };

    trackView("Subscribe");
  }
  
  componentWillMount() {
    beep();
  }
  
  handleSubmit = e => {
    e.preventDefault();
  
    if(!this.state.email) {
      this.setState({
        error: "Please enter your email address.",
        isErrorVisible: true,
      });
      return;
    }
    
    if(!emailExp.test(this.state.email)) {
      this.setState({
        error: "Please enter a valid email address.",
        isErrorVisible: true,
      });
      return;
    }
    
    if(!this.state.condition) {
      this.setState({
        error: "Please select a condition.",
        isErrorVisible: true,
      });
      return;
    }
  
    // fetch(`https://ct.stanford.edu/api/v1/subscriptions`, {
    fetch(`https://med.stanford.edu/clinicaltrials/api/v1/subscriptions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8"
      },
      body: JSON.stringify({ 
        "email": this.state.email, 
        "recruitingStatusCode": "RECRUITING",  
        "serviceLineId": "Cancer", 
        "conditionId": this.state.condition,
      })
    });
    
    this.setState({isSent:true});
  }
  
  renderError() {
    const isActive = !!this.state.isErrorVisible;
    
    return (
      <div 
        className={`subscribe-error ${!!isActive ? 'is-active' : ''}`}
        onClick={() => this.setState({isErrorVisible:false})}>
        <span className='subscribe-error-text'>{this.state.error}</span>
      </div>
    );
  }
  
  renderForm() {
    const { email, condition } = this.state;
    
    const allConditions = [];
    conditions.forEach(condition => {
      allConditions.push({
        id: condition.id,
        description: condition.description.trim(),
      });
      
      if(condition.subConditions) {
        condition.subConditions.forEach(condition => {
          allConditions.push({
            id: condition.id,
            description: condition.description.trim(),
          });
        });
      }
    });
    console.log('all conditions', allConditions);
    
    return (
      <div>
        <h1 className="subscribe-header">{lang('subscription-page-title')}</h1>
        <h3 className="subscribe-subheader">{lang('subscription-page-subtitle')}</h3>
        
        <form className="subscribe-form" onSubmit={this.handleSubmit}>
          <input 
            type="text" 
            className="subscribe-field subscribe-email-field"
            placeholder={lang('email')} 
            value={email}
            onChange={e => this.setState({email:e.target.value, isErrorVisible:false})}
          />
          <select
            className="subscribe-field subscribe-condition-field"
            value={condition}
            onChange={e => this.setState({condition:e.target.value, isErrorVisible:false})}>
            <option value="">Select Condition</option>
            {allConditions.map(c => 
              <option key={c.id} value={c.id}>{c.description}</option>
            )}
          </select>
          <div>
            <button type="submit" className="subscribe-submit">{lang('subscription-page-form-submit-button')}</button>
          </div>
        </form>
      </div>
    );
  }
  
  renderThanks() {
    return (
      <div>
        <h1 className="subscribe-header">{lang('subscription-thanks-page-title')}</h1>
        <h3 className="subscribe-subheader">{lang('subscription-thanks-page-subtitle')}</h3>
        <div className="subscribe-thanks-nav">
          <Link to="/find" className="subscribe-submit">{lang('contact-thanks-page-main-menu')}</Link>
        </div>
      </div>
    );  
  }
  
  render() {
    const { isSent } = this.state;
    
    return (
      <div className="subscribe">
        
        <div className="subscribe-content-row">
        
          <article className="subscribe-content">
            {isSent ? this.renderThanks() : this.renderForm()}
            {this.renderError()}
          </article>
          
          <aside className="subscribe-sidebar">
            <h5 className="subscribe-sidebar-title">{lang('contact-page-sidebar-title')}</h5>
            
            <a href="tel:6504987061" className="subscribe-sidebar-link">
              <Icon name="phone" className="subscribe-sidebar-link-icon"/> 650.498.7061
            </a>
            <a href="mailto:ccto-office@stanford.edu" className="subscribe-sidebar-link">
              <Icon name="mail" className="subscribe-sidebar-link-icon"/> ccto-office@stanford.edu
            </a>
            
            <div className="subscribe-sidebar-survey">
              <h5 className="subscribe-sidebar-title">{lang('contact-page-sidebar-survey-title')}</h5>
              <p className="subscribe-sidebar-subtitle">{lang('contact-page-sidebar-survey-subtitle')}</p>
              
              <Link to="/survey" className="subscribe-sidebar-button">
                {lang('contact-page-sidebar-survey-button')}
              </Link>
            </div>
          </aside>
          
        </div>
        
        <div className="subscribe-menu-row">
          <div className="subscribe-menu">
            <div className="subscribe-menu-back" onClick={hashHistory.goBack}>
              <h5 className="subscribe-menu-subtitle"> <Icon name="prev" className="trial-menu-back-icon"/> {lang('subscription')}</h5>
            </div>
            <Link to="/menu" className="subscribe-menu-main">
              {lang('main-menu')} <Icon name="menuWhite" className="subscribe-menu-main-icon"/>
            </Link>
          </div>
          
          <div className="subscribe-menu-mobile">
            <div className="subscribe-menu-back" onClick={hashHistory.goBack}>
              <Icon name="prev" className="subscribe-menu-back-icon"/>
            </div>
            <h5 className="subscribe-menu-subtitle">{lang('subscription')}</h5>
          </div>
        </div>
        
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Subscribe.js